import { useMemo } from 'react';
import { useAutoratingStore } from './Autorating.store';
import { TextArea, CustomButton } from 'shared_ui_components';
import AIFeedback from 'shared_ui_components/AIFeatures/AIFeedback/AIFeedback';
import styles from './Autorating.module.scss';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import FeedbackTooltip from './FeedbackTooltip';
const useStyles = makeStyles({
  button: {
    color: '#E83A3A !important',
    border: '1px solid #E83A3A !important',
    '&:hover': {
      backgroundColor: 'rgba(234, 58, 58, 0.1) !important',
    },
  },
});

const FeedbackAI = ({
  item_id,
  question_id,
  initialValue,
  handleDoubleChangeFromAI = () => null,
  status,
  error_msg,
}) => {
  const classes = useStyles();

  const tempEditFeedback = useAutoratingStore((state) => state?.tempEditFeedback);
  const editRemark = useAutoratingStore((state) => state?.editRemark);
  const deleteItem = useAutoratingStore((state) => state?.deleteItem);
  const setSaveEdition = useAutoratingStore((state) => state?.setSaveEdition);

  const value = useMemo(() => {
    if (!tempEditFeedback) return '';
    const index = tempEditFeedback.findIndex(
      (x) => x?.id_question === item_id && x?.id_feedback === question_id
    );
    return index === -1 ? '' : tempEditFeedback[index].answer.remarks;
  }, [tempEditFeedback, item_id, question_id]);

  const valueRating = useMemo(() => {
    if (!tempEditFeedback) return '';
    const index = tempEditFeedback.findIndex(
      (x) => x?.id_question === item_id && x?.id_feedback === question_id
    );
    return index === -1 ? '' : tempEditFeedback[index].answer.rating;
  }, [tempEditFeedback, item_id, question_id]);

  const isEditing = useMemo(() => {
    if (!tempEditFeedback) return false;
    return tempEditFeedback.some(
      (i) => i?.id_question === item_id && i?.id_feedback === question_id
    );
  }, [tempEditFeedback, item_id, question_id]);

  const handleDiscard = () => {
    if (tempEditFeedback.length === 1) setSaveEdition();
    deleteItem({ id: item_id, id_fdbk: question_id });
  };

  const handleSave = () => {
    handleDoubleChangeFromAI(
      [
        { key: 'rating', value: valueRating },
        { key: 'remarks', value: value },
      ],
      item_id,
      question_id,
      status
    );
    if (tempEditFeedback.length === 1) setSaveEdition();
    deleteItem({ id: item_id, id_fdbk: question_id });
  };

  return (
    <>
      {status && <FeedbackTooltip />}
      {isEditing ? (
        <div className={styles.editFeedback}>
          <TextArea
            placeholder="Provide your comments"
            rowsMin={8}
            rowsMax={12}
            onChange={(e) => {
              editRemark({ id: item_id, id_fdbk: question_id, comment: e.target.value });
            }}
            value={value}
          />
          <div className={styles.buttonContainer}>
            <CustomButton
              className={classNames('secondaryBtn', classes.button)}
              onClick={handleDiscard}
            >
              Discard
            </CustomButton>
            <CustomButton style={{ backgroundColor: '#2DC38D' }} onClick={handleSave}>
              Save
            </CustomButton>
          </div>
        </div>
      ) : (
        <AIFeedback
          ai_feedback={initialValue}
          ai_feedback_status={status}
          assessment
          error_msg={error_msg}
        />
      )}
    </>
  );
};

export default FeedbackAI;
